import { render, staticRenderFns } from "./VerificationChecklistItem.vue?vue&type=template&id=a5003bbe&scoped=true"
import script from "./VerificationChecklistItem.vue?vue&type=script&lang=js"
export * from "./VerificationChecklistItem.vue?vue&type=script&lang=js"
import style0 from "./VerificationChecklistItem.vue?vue&type=style&index=0&id=a5003bbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5003bbe",
  null
  
)

export default component.exports